module.exports = __webpack_public_path__ + "static/media/svg_3_2_1_all.22424076.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/03/02/assets/svg_3_2_1_all.svg
// module id = 493
// module chunks = 0